import React from "react";
import {
  makeStyles,
  Typography,
  Box,
  Grid,
  Container,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@material-ui/core";
import { useHistory } from "react-router";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BugReportIcon from "@material-ui/icons/BugReport";

const scanData = [
  {
    number: "1",
    img: "images/bitcoin.jpg",
    texthead: " BitcoMine",
    scoreno: "96.7",
    interest: "4,502",
    network: "  BSC",
    price: "  $0.024",
    marketcap: "$5,014,174,648",
    age: "189 Days",
    report: " BitcoMine",
    report: "images/images1.png",
  },
  {
    number: "2",
    img: "images/bitcoin.jpg",
    texthead: "MillionStarter",
    scoreno: "21.6",
    interest: "4,502",
    network: "  BSC",
    price: "  $1.42",
    marketcap: "$5,014,174,648",
    age: "24 Days",
    report: " BitcoMine",
  },

  {
    number: "3",
    img: "images/bitcoin.jpg",
    texthead: " FoxGirl",
    scoreno: "86.4",
    interest: "4,502",
    network: "  BSC",
    price: "  $0.469",
    marketcap: "$5,014,174,648",
    age: "75 Days",
    report: " BitcoMine",
  },
  {
    number: "4",
    img: "images/bitcoin.jpg",
    texthead: " NFTitties",
    scoreno: "87.9",
    interest: "4,502",
    network: "  ETH",
    price: "  $0.0087",
    marketcap: "$5,014,174,648",
    age: "92 Days",
    report: " BitcoMine",
  },
  {
    number: "5",
    img: "images/bitcoin.jpg",
    texthead: "Space Token",
    scoreno: "58.4",
    interest: "4,502",
    network: "  BSC",
    price: "  $0.0384",
    marketcap: "$5,014,174,648",
    age: "42 Days",
    report: " BitcoMine",
  },
  {
    number: "6",
    img: "images/bitcoin.jpg",
    texthead: "Floki City",
    scoreno: "61.6",
    interest: "4,502",
    network: "  BSC",
    price: "  $0.088",
    marketcap: "$5,014,174,648",
    age: "37 Days",
    report: " BitcoMine",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {},
}));

function Datatable(props) {
  const classes = useStyles();
  const history = useHistory();

  const { data } = props;
  return (
    <Box className={classes.mainbox}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          className="text-center"
          style={{ display: "block" }}
        >
          <Grid item xs={12} md={12}>
            <Paper variant="outlined" elevation={5} style={{ padding: "11px" }}>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead className="TableHead">
                    <TableRow>
                      <TableCell>TOKEN</TableCell>
                      <TableCell>SCORE</TableCell>
                      <TableCell>INTEREST</TableCell>
                      <TableCell>NETWORK</TableCell>
                      <TableCell>PRICE</TableCell>
                      <TableCell>MARKET CAP</TableCell>
                      <TableCell>AGE</TableCell>
                      <TableCell>REPORT</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className={classes.TableBody}>
                    {scanData &&
                      scanData.map((data) => (
                        <TableRow key={data?.name}>
                          <TableCell
                            style={{
                              border: "1px solid rgba(224, 224, 224, 1)",
                            }}
                            className="table-data p-l-10"
                          >
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              width="100%"
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                width="100%"
                              >
                                <Typography style={{ color: "gray" }}>
                                  {data?.number}
                                </Typography>
                                <Box>
                                  <img
                                    src={data?.img}
                                    alt=""
                                    width="100%"
                                    style={{
                                      width: "100%",
                                      maxWidth: "35px",
                                      borderRadius: "50%",
                                      margin: "0 7px",
                                    }}
                                  />
                                </Box>
                                <Box>
                                  {data?.texthead}
                                  <Box className={classes.box}>
                                    <Typography style={{ color: "gray" }}>
                                      &BME
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                              <Box display="flex" justifyContent="flex-end">
                                <CheckCircleIcon />
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell className="table-data">
                            {data?.scoreno}
                          </TableCell>

                          <TableCell className="table-data">
                            {data?.interest}
                          </TableCell>
                          <TableCell className="table-data">
                            {data?.network}
                          </TableCell>
                          <TableCell className="table-data">
                            {data?.price}
                          </TableCell>
                          <TableCell className="table-data">
                            {data?.marketcap}
                          </TableCell>
                          <TableCell className="table-data">
                            {data?.age}
                          </TableCell>
                          <TableCell>
                            <BugReportIcon />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Datatable;
